import { useEffect } from 'react';

import { getYandexCounterEventName, YA_COUNTERS_IDS } from 'shared/config/analytics';
import { getCookie } from 'shared/lib/cookieMethods';

import { getAnalyticsIds, setAnalyticsBase, updateAnalyticsIds, collectOrderAnalytics } from 'entities/analytics';

import type { AppStore } from 'app/MyApp';

export const useSetCookiesOnMount = (reduxStore: AppStore) => {
  const { dispatch, getState } = reduxStore || {};
  const { whiteLabel, appConfig } = getState() || {};
  const isWL = whiteLabel.isWL || false;
  const originalUrl = appConfig?.config?.originalUrl;

  useEffect(() => {
    (async () => {
      const base = await collectOrderAnalytics(getCookie, originalUrl, isWL);

      if (base) {
        dispatch(setAnalyticsBase(base));
      }
    })();
  }, [dispatch, isWL, originalUrl]);

  // после инициализации Яндекс.Метрики получаем ID и обновляем в Redux
  useEffect(() => {
    const handler = () => {
      const analyticsIds = getAnalyticsIds(isWL);

      dispatch(updateAnalyticsIds(analyticsIds));
    };

    Object.values(YA_COUNTERS_IDS).forEach((counterId) => {
      document.addEventListener(getYandexCounterEventName(counterId), handler);
    });

    return () => {
      Object.values(YA_COUNTERS_IDS).forEach((counterId) => {
        document.removeEventListener(getYandexCounterEventName(counterId), handler);
      });
    };
  }, [dispatch, isWL]);
};
